import { withSizes } from 'react-sizes';

import { mapSizesToProps } from 'client/helpers/sizes';

import ResearchersHomeBlock from './researchers-home-block';

export default withSizes(mapSizesToProps)(ResearchersHomeBlock);
